import angular from 'angular';
import SelectComponent from './select.component';

const select = angular
	.module('frSelect', [])
	.component('frSelect', SelectComponent)
	.name;

export default select;



// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/common/select/select.module.js